
import React, { useState, useEffect } from "react";
import ConnectAPI from "../../services/api";
import { authenticationService } from "../../services/context/AuthService";
import Swal from "sweetalert2";
import { Row, Col, Container } from 'react-bootstrap';
import moment from "moment";
import {Modal  , Button ,IconCheckmark, Stepper, TextArea, Select,TextBox, List ,ListItem, IconX, Toggle} from "@veneer/core";

import { useTranslation } from "react-i18next";
import XLSX from 'xlsx';
import $, { map } from 'jquery';

const Email_view = ({ onShowModal, setOnShowModal, onCloseSCDetailsModal,details,isnew}) => {
    const connectApi = new ConnectAPI();
    const { t, i18n } = useTranslation();
    const [audience, setaudience]=useState();
    const [emails, setemails]=useState([]);
    const [txtemails, settxtemails]=useState("");
    const [optionsrole, setoptionrole]=useState([]);
    const [optionsChannels, setoptionsChannels]=useState([]);
    const [roleselect, setroleselect]=useState({ value: [] } );
    const [regionlist, setregionlist]=useState([]);
    const [subregion, setsubregion]=useState({ value: [] } );
    const [NewStep, setNewStep]=useState("1");
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [Emailbody,setEmailbody]=useState("");
    const [channelselect2, setchannelselect2]=useState();
    const [optionsEndUSer, setoptionsEndUSer]=useState([]);
    const [channelselect, setchannelselect]=useState({ value: [] } );
    const [enduserselect, setenduserselect]=useState({ value: [] } );
    const [savetemplate, setsavetemplate]=useState(false);
    const [subject, setsubject]=useState();
    const [enablebtn, setenablebtn]=useState(true);
    const [loadingbtn, setloadingbtn]=useState(false);

    useEffect(()=>{
        if (isnew=="NO"){
            setEmailbody(details.body);
            const deepcopyItems = defaultJson.map((item) => ({ ...item }));
            setNewStep("1");
            setStepItems(deepcopyItems);
            setCurrentIndex(0);
            setenablebtn(false);
            setsubject(details.description);
            
            if (details.audiencelevel=="role" && details.audience.toString().includes('R')==true){
                details.audiencelevel="role & subregion";
            }
            setaudience(details.audiencelevel);
            switch(details.audiencelevel){
                case "email":
                    var array=details.audience.toString().split(",");
                    var old_emails=emails;
                    var new_emails=old_emails.concat(array)
                    setemails(new_emails);
                    break;
                case "role":
                    var array=details.audience.toString().split(",");
                    setroleselect({ value: array });
                    break;
                case "subregion":
                    var array=details.audience.toString().split(",");
                    const numbers = array.map((n) => {
                        return parseInt(n, 10);
                    });
                    setsubregion({ value: numbers });
                    break;
                case "role & subregion":
                    var array=details.audience.toString().split(",");
                    var role=[];
                    var region=[];
                    var encontrado=false;
                    array.map((n)=>{
                        if (n=="R"){
                            encontrado=true;
                        }else{
                            if (encontrado==true){
                                region.push(parseInt(n,10));
                            }else{
                                role.push(n);
                            }
                        }
                    });
                    setroleselect({value:role});
                    setsubregion({value: region});
                    break;
                case "channel":
                    var array=details.audience.toString().split(",");
                    setchannelselect({value: array});
                    break;
            }
        }else{
            setaudience("");
            setroleselect({ value: [] } );
            setsubregion({ value: [] } );
            setemails([]);
            settxtemails("");
            setsubject("");
            const deepcopyItems = defaultJson.map((item) => ({ ...item }));
            setNewStep("1");
            setStepItems(deepcopyItems);
            setCurrentIndex(0);
            setEmailbody("");
        }
    },[details]);


    useEffect(()=>{

        connectApi
        .getWithParams(
          "api/Channels/getendusersnoti",
          channelselect2 ,
          consolidchannels
        )
    },[channelselect2]);
    const consolidchannels=(status,data)=>{
        var enduser=[];
        data.forEach(element => {
            enduser.push({
                value:element.idEndUser,
                label:element.name
            });
        });
        setoptionsEndUSer(enduser);
    }
    const channelchange = ({ value }) => {
        const valueCopy = [...channelselect.value];
        const isOptionSelected = valueCopy.includes(value);
    

        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else {
          valueCopy.push(value);
        }
        setchannelselect({ value: valueCopy });
        setenablebtn(false);
    }
    const enduserchange = ({ value }) => {
        const valueCopy = [...enduserselect.value];
        const isOptionSelected = valueCopy.includes(value);
    

        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else {
          valueCopy.push(value);
        }
        setenduserselect({ value: valueCopy });
        setenablebtn(false);
    }
    const handlechannelschange = (name) => (event) => {
        setchannelselect2(event.value);
    };
    const defaultJson = [
        {
          label: t("Email"),
          status: 'incomplete',
          step: '1',
        },
        {
          label: t("Audience"),
          status: 'incomplete',
          step: '2',
        },
        {
            label: t("View"),
            status: 'incomplete',
            step: '3',
        },    
    ];
    const [stepItems, setStepItems] = React.useState(defaultJson);
    const handletoggle=(event)=>{
        setsavetemplate(event);
    }
    

    useEffect(()=>{
        connectApi
        .get(
          "api/Channels/getconfignoti",
          "",
          consolidconfig
        )
    },[]);

    const formStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: "100%",
        marginTop: 20
    };
    const check_next_btn=()=>{
        if (NewStep=="1"){
            if (subject!="" && Emailbody!=""){
                setenablebtn(false);
            }
        }

    }
    const steps=()=>{
        if (NewStep=="1"){
            return (
                <>
                <TextBox
                    id="text-box-uncontrolled"
                    label={t("subject")}
                    value={subject}
                    onChange={(value) => {
                        setsubject(value);
                        check_next_btn()
                    }}
                />
                <TextArea
                    id="Email"
                    label={t("Email")}
                    value={Emailbody}
                    onChange={(e) => {
                        setEmailbody(e.replace(/\n/g,"\r\n"));
                        check_next_btn();
                    }}
                />
                </>
            );
        }
        if (NewStep=="2"){
            return (
                <>
                    
                <Row>
                    <Col xs="6" md="6">
                        {t("select audience")}
                        <Select
                            options={[
                                { value: "email", label: 'Email' },
                                { value: "role", label: 'Role' },
                                { value: "subregion", label: 'Subregion' },
                                { value: "role & subregion", label: 'Role and Subregion' },
                                { value: "enduser", label: 'End User' },
                                { value: "channel", label: 'Channel' },
                            ]}
                            id="select-usage"
                            label={t("Audience")}
                            value={[audience]}
                            onClear={handleClearAudience()}
                            onChange={handleSelecAudience()}
                        />
                    </Col>
                    <Col xs="6" md="6">
                        {select_audience()}
                    </Col>
                </Row>
                </>
            );
        }
        if (NewStep=="3"){
            return(
                <>
                <Row>
                    <Col xs="12">
                        <Toggle onChange={handletoggle}
                            on={savetemplate}
                            label={t("save_template")}
                        /> 
                    </Col>
                </Row>
                <Row>
                    <Col xs="8" md="8"  >
                        <div><b>{t("subject")}</b>:{subject}</div>

                        <div style={{height:"auto", maxHeight:"400px", overflow:"auto"}}>
                            {Emailbody.split('\r\n').map(en=>{return(<><p>{en}</p></>)})}
                        </div>
                    </Col>
                    <Col xs="4" md="4">
                        {(audience=="role")?(
                            <>
                                <div><b>{t("audience")}:</b> Role</div>
                                {optionsrole.map((item, key) => {
                                    if (roleselect.value.indexOf(item.value) > -1){
                                        return (
                                            <>
                                                <p><b>{item.label}</b></p>
                                            </>

                                        );
                                    }
                                })}
                            </>
                        ):(
                            (audience=="email")?(
                                <>
                                    <div><b>{t("audience")}:</b> Emails</div>
                                    <List css={{padding: '20px', height: '200px', overflowY: 'auto'}}>
                                    {
                                        emails.map((item, key) => {
                                            return(
                                                <>
                                                <ListItem 
                                                    centerArea={<div>{item}</div>}
                                                />
                                                </>
                                            )
                                        })
                                    }
                                </List>
                                </>
                                
                            ):(
                                (audience=="subregion")?(
                                    <>
                                        <div><b>{t("audience")}:</b> Subregions</div>
                                        {regionlist.map((item, key) => {
                                            if (subregion.value.indexOf(item.value) > -1){
                                                return (
                                                    <>
                                                        <p><b>{item.label}</b></p>
                                                    </>

                                                );
                                            }
                                        })}
                                    </>
                                    
                                ):((audience=="enduser")?(
                                    <>
                                        <div><b>{t("audience")}:</b> End Users</div>
                                        {enduserselect.value.map((item, key) => {
                                                return (
                                                    <>
                                                        <p><b>{item}</b></p>
                                                    </>

                                                )
                                            })}
                                    </>
                                    ):((audience=="channel")?(
                                        <>
                                            <div><b>{t("audience")}:</b> Channels</div>
                                            {optionsChannels.map((item, key) => {
                                                if (channelselect.value.indexOf(item.value) > -1){
                                                    return (
                                                        <>
                                                            <p><b>{item.label}</b></p>
                                                        </>

                                                    );
                                                }
                                            })}
                                        </>
                                        ):((audience=="role & subregion")?(
                                            <>
                                                <div><b>{t("audience")}:</b> Roles y Subregion</div>
                                                <p><b>Rols</b></p>
                                                {optionsrole.map((item, key) => {
                                                    if (roleselect.value.indexOf(item.value) > -1){
                                                        return (
                                                            <>
                                                                <p>{item.label}</p>
                                                            </>

                                                        );
                                                    }
                                                })}

                                                <p><b>Subregion</b></p>
                                                {regionlist.map((item, key) => {
                                                    if (subregion.value.indexOf(item.value) > -1){
                                                        return (
                                                            <>
                                                                <p>{item.label}</p>
                                                            </>

                                                        );
                                                    }
                                                })}
                                            </>
                                        ):(""))))
                            )
                        )}
                    </Col>
                </Row>  
                </>
            );
        }

       
    }
    const consolidconfig = (status, data) => {
        setregionlist([
            { value: 2, label: 'Brazil' },
            { value: 3, label: 'Mexico' },
            { value: 31, label: 'MCA North' },
            { value: 32, label: 'MCA South' },
        ]);

        var options=[];
        var channels=[];
        var enduser=[];
        data.roles.forEach(element => {
            options.push({
                value:element.idRole,
                label:element.role
            });
        });

        data.channels.forEach(element => {
            channels.push({
                value:element.idCustomer,
                label:element.name
            });
        });

    
        setoptionsChannels(channels);
        setoptionrole(options);
    }
    function delete_email(args){
        let liItem = args.target.closest('li').getElementsByClassName("css-1wok153");
        var old_emails=emails;
        var new_emails= emails.filter((item) => item !== liItem[0].innerText)
        if (new_emails.length>0){
            setenablebtn(false);
        }else{
            setenablebtn(true);
        }
        setemails(new_emails);
    }
    const handleChange = ({ value }) => {
        const valueCopy = [...roleselect.value];
        const isOptionSelected = valueCopy.includes(value);
  
        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else {
          valueCopy.push(value);
        }
        
        setroleselect({ value: valueCopy });
        setenablebtn(false);
    }
    const handleChange2 = ({ value }) => {
        const valueCopy = [...subregion.value];
        const isOptionSelected = valueCopy.includes(value);
    

        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else {
          valueCopy.push(value);
        }
        setsubregion({ value: valueCopy });
        setenablebtn(false);
    }
    const select_audience=()=>{
        switch(audience){
            case "role":
                return (
                    <>
                    {t("select channel")}
                    <Select
                        multiple
                        options={optionsrole}
                        id="roles"
                        label="Select Role"
                        value={roleselect.value}
                        onClear={() => {
                            setenablebtn(true);
                            setroleselect({ value: [] })}}
                        onChange={handleChange}
                    />
                    </>
                );
                break;
            case "email":
                return (
                    <>
                        <Row>
                            <Col md="8">
                                {t("Enter Emails")}
                                <TextBox
                                    id="txtemails"
                                    label="Email"
                                    value={txtemails}
                                    onChange={(e) => {
                                        settxtemails(e);
                                    }
                                    }
                                />
                            </Col>
                            <Col md="4">
                                <br/>
                                <Button
                                    small
                                    name="add"
                                    onClick={()=>{
                                        if (txtemails!=""){
                                            var array=txtemails.split(",");
                                            var last=[];
                                            array.map((item, key) => {
                                                last.push(item.trim());
                                            });
                                            var old_emails=emails;
                                            var new_emails=old_emails.concat(last)
                                            setemails(new_emails);
                                            settxtemails("");

                                            setenablebtn(false);
                                        }
                                        
                                    }}
                                >
                                    Add
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <List css={{padding: '20px', height: '200px', overflowY: 'auto'}}>
                                    {
                                        emails.map((item, key) => {
                                            return(
                                                <>
                                                <ListItem 
                                                    centerArea={<div>{item}</div>}
                                                    rightArea={<Button onClick={delete_email.bind(this)} id={key} aria-label="Actions" leadingIcon={<IconX />} appearance="tertiary" />}
                                                />
                                                </>
                                            )
                                        })
                                    }
                                </List>
                            </Col>
                        </Row>
                        
                    </>
                );
                break;
            case "subregion":
                return (
                    <>
                    {t("select region")}
                    <Select
                        multiple
                        options={regionlist}
                        id="subregion"
                        label="Select Subregion"
                        value={subregion.value}
                        onClear={() => {
                            setsubregion({ value: [] });
                            setenablebtn(true);
                        }}
                        onChange={handleChange2}
                    />
                    </>
                );
                break;
            case "enduser":
                return (
                    <>
                    {t("select_channel")}
                    <Select
                        
                        options={optionsChannels}
                        id="channels"
                        label="Select Channel"
                        value={[channelselect2]}
                        onClear={() => setchannelselect2()}
                        onChange={handlechannelschange()}
                    />

                    {t("select enduser")}
                    <Select
                        multiple
                        options={optionsEndUSer}
                        id="enduser"
                        label="Select End User"
                        value={enduserselect.value}
                        onClear={() => {
                            setenduserselect({ value: [] });
                            setenablebtn(true);
                        }}
                        onChange={enduserchange}
                    />
                    </>
                );
                break;
            case "channel":
                return (
                    <>
                    {t("select channel")}
                    <Select
                        multiple
                        options={optionsChannels}
                        id="channels"
                        label="Select Channel"
                        value={channelselect.value}
                        onClear={() => {
                            setchannelselect({ value: [] });
                            setenablebtn(true);
                        }}
                        onChange={channelchange}
                    />
                    </>
                );
                break;
            case "role & subregion":
                return (
                    <>
                        {t("select role")}
                        <Select
                            multiple
                            options={optionsrole}
                            id="roles"
                            label="Select Role"
                            value={roleselect.value}
                            onClear={() => {
                                setroleselect({ value: [] });
                                setenablebtn(true);
                            }}
                            onChange={handleChange}
                        />

                        {t("select region")}
                        <Select
                            multiple
                            options={[
                                { value: 2, label: 'Brazil' },
                                { value: 3, label: 'Mexico' },
                                { value: 31, label: 'MCA North' },
                                { value: 32, label: 'MCA South' },
                            ]}
                            id="subregion"
                            label="Select Subregion"
                            value={subregion.value}
                            onClear={() => {
                                setsubregion({ value: [] });
                                setenablebtn(true);
                            }}
                            onChange={handleChange2}
                        />

                    </>
                );
                break;
        }
    }
    const handleClearAudience = (name) => (event) => {
        setaudience();
    };
    const handleSelecAudience = (name) => (event) => {
        setaudience(event.value);
    };
    

    const buttonsContainer = { display: 'flex', justifyContent: 'space-between', marginTop: 20 };
    const nextButtonStyle = { width: '45%' };
    const resetButtonStyle = { width: '45%' };
    const handleResetButtonOnChange = () => {
        const deepcopyItems = defaultJson.map((item) => ({ ...item }));
        setNewStep("1");
        setStepItems(deepcopyItems);
        setCurrentIndex(0);
        setaudience("");
        setroleselect({ value: [] } );
        setsubregion({ value: [] } );
        setEmailbody("");
        setemails([]);
        setsubject("");
        settxtemails("");
        setsavetemplate(false);

    };
    const handleBackButtonOnChange=()=>{
        const newStepItems = [...stepItems];
        const newSelectedItem = newStepItems[currentIndex - 1];
        const oldSelectedItem = newStepItems[currentIndex];

        setNewStep(parseInt(NewStep)-1);
        newSelectedItem.status = 'current';
        oldSelectedItem.status = 'incomplete';
        oldSelectedItem.step = NewStep;
    
        setCurrentIndex(currentIndex - 1);
        setStepItems(newStepItems);
        setenablebtn(false);
    }
    const handleSubmit = () => {
        setloadingbtn(true);
        let data= new FormData();
        switch(audience){
            case "role":
                data.append("audiencelevel","role");
                var string="";
                roleselect.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audience",string);
                break;
            case "email":
                data.append("audiencelevel","email");
                var string="";
                emails.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audience",string);
                break;
            case "subregion":
                data.append("audiencelevel","subregion");
                var string="";
                subregion.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audience",string);
                break;
            case "enduser":
                data.append("audiencelevel","enduser");
                var string="";
                enduserselect.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audience",string);
                break;
            case "channel":
                var string="";
                channelselect.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audiencelevel","channel");
                data.append("audience",string);
                break;
            case "role & subregion":
                var string="";
                roleselect.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                string=string+",R";
                subregion.value.map((item, key) => {
                    
                    string=string+","+item;
                
                    
                });
                data.append("audiencelevel","role");
                data.append("audience",string);
                break;
        }
        data.append("description",subject);
        data.append("emailbody",Emailbody);
        var url="";
        if (savetemplate==true){
            url="api/channels/saveemailtemplate";
        }
        if (savetemplate==false){
            url="api/channels/emailsend";
        }
        connectApi.post(url,data,alertssended).catch((error) => {
            setloadingbtn(false);
            setOnShowModal(false);
            Swal.fire(
                'Error ' ,
                error,
                'error'
              );
        })
    }

    const alertssended=(status,response)=>{
        if (status==200){
            window.location.href = window.location.href;
        }else{
            Swal.fire(
                'Error ' + response,
                response,
                'error'
              );
        }
    }
    const handleNextButtonOnChange = () => {
        const newStepItems = [...stepItems];
        const newSelectedItem = newStepItems[currentIndex + 1];
        const oldSelectedItem = newStepItems[currentIndex];
        setNewStep(newSelectedItem.step);
        
        newSelectedItem.status = 'current';
    
        oldSelectedItem.status = 'complete';
        oldSelectedItem.step = <IconCheckmark filled />;
    
        setCurrentIndex(currentIndex + 1);
        setStepItems(newStepItems);
        if (isnew=="NO"){
            setenablebtn(false);
        }else{
            setenablebtn(true);
        }
        
    };
    const txtSave=()=>{
        if (savetemplate==true){
            return (
                <>
                {t("save_button")}
                </>
            );
        }
        if (savetemplate==false){
            return (
                <>
                    {t("send")}
                </>
            );
        }
    }
    return (
        <>
        <Modal
            id="regular-modal"
            show={onShowModal}
            onClose={() => { onCloseSCDetailsModal(); }}
            css={{
                '.vn-modal--content': {
                    width: "800px !important",
                    height:"750px !important",
                },
            }}
            title="Emails"
        >
           <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                <Stepper steps={stepItems} />
                <div style={formStyle}>
                    {steps()}
                    <div style={buttonsContainer}>
                        <Button
                            name="reset"
                            customStyle={resetButtonStyle}
                            small
                            onClick={handleResetButtonOnChange}
                        >
                            Reset
                        </Button>
                        {(NewStep!="1")?(
                            <Button
                                name="button"
                                appearance="secondary"
                                small
                                
                                customStyle={resetButtonStyle}
                                onClick={handleBackButtonOnChange}
                            >
                                Back
                            </Button>
                        ):("")}
                        {(NewStep!="3")?(
                            <Button
                                name="button"
                                customStyle={nextButtonStyle}
                                small
                                disabled={enablebtn}
                                onClick={handleNextButtonOnChange}
                            >
                                Next
                            </Button>
                        ):(

                            <Button
                                name="button"
                                customStyle={nextButtonStyle}
                                loading={loadingbtn}
                                small
                                onClick={handleSubmit}
                            >
                                {txtSave()}
                            </Button>
                        )}
                        
                    </div>
                </div>
            </div>
        </Modal>
        </>
    );
}
export default Email_view;
